import FullPageLoader from 'components/common/FullPageLoader';
import AccountForm from 'components/type/AddType';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchSingleType } from 'slices/typeSlice';
import { typesSelector } from 'slices/typeSlice';

const UpdateAccount = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { singleType, loader } = useSelector(typesSelector);
    const { id } = useParams();

    useEffect(() => {
            if (id) {
                dispatch(fetchSingleType(id));
            }
        }, [dispatch, id]);

   if (loader) return <FullPageLoader />;
   
    if (!singleType) return <div>No Sub Client found</div>;
    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                    <h2 className="main_heading">Update Accounts</h2>
                </div>
                {/* <LiveClock /> */}
            </div>

            <AccountForm item={singleType} />
        </div>
    );
};

export default UpdateAccount;
